<template>
  <v-simple-table class="striped-table" style="border: 1px dashed #ccc">
    <template v-slot:default>
      <thead>
        <tr class="grey lighten-3">
          <th></th>
          <template v-if="item.shifts && item.shifts.length">
            <th
              v-for="shift in item.shifts"
              :key="`shift-header-${shift.shift}`"
              class="text-center font-weight-bold"
            >
              {{ $t(`shift_${shift.shift}`) }}
            </th>
          </template>
          <th class="text-center font-weight-bold">
            {{ device.isMobile ? "Σ" : $t("total") || "ukupno" }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Food Row -->
        <tr class="orange lighten-4">
          <td class="font-weight-bold">
            {{ item.isTotal ? $t("total") : toLatin(item.food_name) }}
          </td>
          <template v-if="item.shifts && item.shifts.length">
            <td
              v-for="shift in item.shifts"
              :key="`food-shift-${shift.shift}`"
              class="text-center font-weight-bold pa-1"
            >
              <span v-if="item.isTotal">{{ item.shiftTotals[shift.shift] || "" }}</span>
              <v-row v-else no-gutters justify="center">
                <text-field
                  v-model.number="shift.quantity"
                  type="number"
                  hide-details
                  class="centered-input"
                  color="white"
                  style="max-width: 100px"
                  @input="$emit('recalculate')"
                />
              </v-row>
            </td>
          </template>
          <td class="text-center font-weight-bold">
            {{ item.totalShiftQuantity }}
          </td>
        </tr>
        <!-- Groceries Rows -->
        <template v-if="item.groceries && item.groceries.length">
          <tr v-for="gr in item.groceries" :key="gr.id">
            <td class="font-weight-medium">{{ gr.name }}</td>
            <template v-if="item.shifts && item.shifts.length">
              <td
                v-for="shift in item.shifts"
                :key="`gr-shift-${shift.shift}-${gr.id}`"
                class="text-center"
              >
                {{ gr.shiftValues[shift.shift] }}
              </td>
            </template>
            <td class="text-center font-weight-medium">
              {{ gr.total }}
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "RecipeTable",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
  font-weight: bold;
}

.centered-input >>> .v-input__control {
  min-height: 32px;
}

.centered-input >>> .v-text-field__details {
  display: none;
}

/* Mobile styles */
@media (max-width: 960px) {
  .centered-input >>> input {
    font-size: 12px !important;
    padding: 2px 4px !important;
  }
  .centered-input >>> .v-input__slot {
    min-height: 28px !important;
    padding: 2px 4px !important;
  }

  .centered-input >>> .v-input__control {
    min-height: 28px !important;
  }
}
</style>
